import Vue from "vue";
import __dayjs from "dayjs";
import dayOfYear from "dayjs/plugin/dayOfYear";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import weekday from "dayjs/plugin/weekday.js";
import "dayjs/locale/ko";

__dayjs.extend(dayOfYear);
__dayjs.extend(timezone);
__dayjs.extend(utc);
__dayjs.extend(weekday);
__dayjs.locale("ko");
__dayjs.tz.setDefault("Asia/Seoul");

/**
 * @param {Vue} Vue
 * @param {*} options
 */
const install = function (Vue, options) {
    Vue.prototype.$dayjs = __dayjs;
};

Vue.use({ install });

export const dayjs = __dayjs;

export default dayjs;
